export default "__VITE_ASSET__Dt_b$GnH__"